/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */

/**
 * Campaigns types
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.12.0
 */

export enum ECampaignsType {
    account = 'account',
    subscriber = 'subscriber',
}

export interface ICampaignsTable {
    description: string;
    name: string;
    id: string;
}

export interface ICampaignsRouteFilter {
    type: ECampaignsType;
    entityId: number;
}

